<template>
  <div class="c-serviceSearchHeaderFacetTab">
    <BRadioButton
      v-model="innerValue"
      :native-value="master.id"
      class="c-serviceSearchHeaderFacetTab_button"
      :class="{ 'is-focused': isFocused }"
    >
      <slot
        v-for="slotName in Object.keys($slots)"
        :name="slotName"
        :slot="slotName"
      />
      <CoconalaIcon
        class="c-serviceSearchHeaderFacetTab_checkmark"
        name="check"
        size="8px"
        v-show="isCheckmarked"
      />
    </BRadioButton>
  </div>
</template>
<script>
export default {
  name: 'ServiceSearchHeaderFacetTab',
  props: {
    value: {
      type: Number,
      default: null
    },
    option: {
      type: Object,
      default() {
        return {}
      }
    },
    master: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', {
          key: this.master.key,
          id: val
        })
      }
    },
    isFocused() {
      return this.innerValue === this.master.id
    },
    isCheckmarked() {
      return this.option?.value || this.option?.valuesList.length > 0
    }
  }
}
</script>
<style lang="scss" scoped>
.c-serviceSearchHeaderFacetTab {
  &_button {
    /deep/ .b-radio {
      box-sizing: border-box;
      padding: 4px 18px;
      width: auto;
      height: auto;
      border: 1px solid $color-gray-300;
      border-radius: 5px;
      background: $ds2-color-white;
      color: $color-gray-900;
      text-align: left;
      letter-spacing: 0.05em;
      font-weight: bold;
      font-size: 14px;
      line-height: 21px;
    }
    &.is-focused {
      /deep/ .b-radio {
        border: 1px solid $color-blue-500;
        background: $color-blue-100;
        box-shadow: none !important;
        color: $color-blue-500;
      }
    }
  }
  &_checkmark {
    position: relative;
    top: -3px;
    left: 4px;
    margin-right: -8px;
    width: 8px;
  }
}

@media (min-width: breakpoint(Search, M) + 1) {
  .c-serviceSearchHeaderFacetTab {
    @include link-effect;
  }
}
</style>
